import { ObjectTypes } from '@diligentcorp/rc-service-object-mapping';
import { isKeyOf } from '@issuemanager/apps/client/utils';
import { useTranslation } from 'react-i18next';

type UseLocalizedRelationshipTypesReturnType = {
  getRelationshipTypeLabel: (value: string | undefined) => string | undefined;
};

export function useLocalizedRelationshipTypes(): UseLocalizedRelationshipTypesReturnType {
  const { t } = useTranslation('common');

  const relationshipTypesMap: Partial<Record<string, string>> = {
    [ObjectTypes.EVIDENCE]: t('relationshipTypes.evidence'),
    [ObjectTypes.ISSUE]: t('relationshipTypes.issue'),
    [ObjectTypes.CONTROL]: t('relationshipTypes.control'),
    [ObjectTypes.PROCESS]: t('relationshipTypes.process'),
    [ObjectTypes.OBJECTIVE]: t('relationshipTypes.objective'),
    [ObjectTypes.CONTROL_ASSESSMENT]: t('relationshipTypes.control-assessment'),
    [ObjectTypes.RISK]: t('relationshipTypes.risk'),
    [ObjectTypes.RISK_MITIGATION]: t('relationshipTypes.risk-mitigation'),
    [ObjectTypes.RISK_EVENT_ASSESSMENT]: t(
      'relationshipTypes.risk-event-assessment',
    ),
    'risk-assessment': t('relationshipTypes.risk-event-assessment'),
    [ObjectTypes.AUDIT]: t('relationshipTypes.audit'),
    [ObjectTypes.ASSET]: t('relationshipTypes.asset'),
    [ObjectTypes.FINDING]: t('relationshipTypes.finding'),
  };

  return {
    getRelationshipTypeLabel: (
      value: string | undefined,
    ): string | undefined => {
      if (!value) return undefined;
      return isKeyOf(value, relationshipTypesMap as Record<string, unknown>)
        ? relationshipTypesMap[value] ?? value
        : value;
    },
  };
}
